import { ProductImage } from '~app/modules/image-carousel/models';
import { Offer } from './offer.model';
import { Brand } from './brand.model';
import { SortedBestOffers } from './sorted-best-offers.model';
import { Attribute } from './attribute.model';
import { Category } from '~app/modules/generic/models';
import { ProductIndexResponse } from '~app/modules/product/models/product-index-response.model';
import { ProductIndexItem } from '~app/modules/product/models/product-index-item.model';
import { NUMBER_0 } from '~shared/constants';
import { BusinessTypeEnum } from '~shared/constants/business-model.enum';

export interface ProductResponse {
  id: string;
  name: string;
  description: string;
  descriptionLong: string;
  images: ProductImage[];
  bestOffer: string | null;
  offers: Offer[];
  category: string;
  quantity?: number;
  keyFeatures: string[];
  manufacturer: string;
  brand: Brand;
  attributes: Attribute[];
  mid: string;
  breadcrumbsFull: Category;
  hiddenOffersCount: number;
  sortedBestOffers: SortedBestOffers;
  hasPromotion: boolean;
  gtin: string;
  tags: string[];
}

export function mapProductIndexItem(
  productIndexResponseItem: ProductIndexItem,
  productIndexResponse: ProductIndexResponse,
  bestOfferId: string,
  businessType: BusinessTypeEnum
): ProductResponse {
  const bestOffersList: string[] = productIndexResponse?.bestOffer?.cheapest[businessType]
    || productIndexResponse?.bestOffer?.cheapest[BusinessTypeEnum.B2B];
  const offers = productIndexResponse.offers.map(Offer.mapOffer).sort(
    (a: Offer, b: Offer) => bestOffersList.indexOf(a.id) - bestOffersList.indexOf(b.id)
  );

  return {
    ...productIndexResponseItem,
    id: productIndexResponseItem?.idItem,
    ...{
      bestOffer: bestOfferId ? bestOfferId : null
    },
    offers,
    category: productIndexResponseItem?.idCategory,
    manufacturer: productIndexResponseItem?.manufacturer?.id,
    brand: productIndexResponseItem?.brandV2 ?
      productIndexResponseItem?.brandV2 :
      productIndexResponseItem?.brand,
    breadcrumbsFull: productIndexResponse?.breadcrumb,
    hiddenOffersCount: NUMBER_0,
    sortedBestOffers: productIndexResponse?.bestOffer,
    hasPromotion: !!productIndexResponse?.promotion?.active,
    tags: productIndexResponse?.tags,
  };
}
